import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { Typography } from 'ck-ui';
import { ProductListingPageContext } from '../context';
import styles from './BYOMobileDescription.module.scss';

const BYOMobileDescription = ({ description }) => {
  const { isMobile } = useContext(ProductListingPageContext);

  if (!isMobile || !description) return null;

  return (
    <div className={styles.root}>
      <Typography align="centered" display="block">
        {/* eslint-disable-next-line react/no-danger */}
        <span dangerouslySetInnerHTML={{ __html: description }} />
      </Typography>
    </div>
  );
};

BYOMobileDescription.propTypes = {
  description: PropTypes.string,
};

BYOMobileDescription.defaultProps = {
  description: null
};

export { BYOMobileDescription };
